module.exports = __webpack_public_path__ + "img/edit-pencil.5741b7f6.svg";